module.exports = __webpack_public_path__ + "3a9692dbeda5d958cf1d4e709c4132d3.png";